import React from 'react';
import {Outlet} from "react-router-dom";

const TalentPoolLayout = (props) => {

    return (
        <Outlet/>
    )
};

export default TalentPoolLayout;